import { styled, Typography, TypographyProps } from "@mui/material";

export const FormTitle = styled((props: TypographyProps) => (
  <Typography variant="h1" align="center" sx={{ mb: 3 }} {...props} />
))(({ theme }) => ({
  "& span": {
    color: theme.palette.primary.main,
  },
}));
